import React from "react";
import { reduxForm, Field } from "redux-form";
import { Form, Button } from "semantic-ui-react";

import capitalize from "lodash/capitalize";

const fields = [
  {
    label: "nombre",
    required: true
  },
  {
    label: "descripcion",
    required: true
  },
  {
    label: "email",
    required: true
  },
  {
    label: "telefono",
    required: true
  }
];

class FormNuevoContacto extends React.Component {
  handleReset = () => {
    this.props.reset();
    this.props.handleDescartar();
  };

  renderField = ({ label, required }) => (
    <Field
      key={label}
      fluid
      id={label}
      name={label}
      type="text"
      component={Form.Input}
      label={capitalize(label)}
      required={required}
    />
  );

  render() {
    const { handleSubmit, pristine, submitSucceeded } = this.props;
    return (
      <Form>
        <Form.Group widths="equal">
          {fields.map(field => this.renderField(field))}
        </Form.Group>
        <Field
          id="notas"
          name="notas"
          type="text"
          component={Form.Input}
          label="Notas"
        />
        <Button
          disabled={pristine || submitSucceeded}
          content="Guardar"
          color="pink"
          onClick={handleSubmit(values => this.props.handleAddContacto(values))}
        />
        <Button content="Descartar" color="pink" onClick={this.handleReset} />
      </Form>
    );
  }
}

export default reduxForm({
  form: "FormNuevaPersonaContacto",
  enableReinitialize: true
})(FormNuevoContacto);



// WEBPACK FOOTER //
// ./src/pages/ventas/ventasNuevaPersonaContacto/FormNuevoContacto.jsx